"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Modal_1 = __importDefault(require("@mui/material/Modal"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var makeModalStylings_1 = __importDefault(require("./makeModalStylings"));
var Modal = function (_a) {
    var children = _a.children, open = _a.open, onClose = _a.onClose;
    var styles = (0, makeModalStylings_1.default)();
    var modalContainerRef = (0, react_1.useRef)(null);
    var getParentElement = function () {
        var modalContainer = modalContainerRef.current;
        if (!modalContainer) {
            return null;
        }
        return modalContainer.parentElement;
    };
    return ((0, jsx_runtime_1.jsx)("div", { ref: modalContainerRef, children: (0, jsx_runtime_1.jsx)(Modal_1.default, { open: open, onClose: onClose, container: getParentElement, style: { position: 'absolute' }, BackdropProps: { style: { position: 'absolute' } }, children: (0, jsx_runtime_1.jsxs)(Box_1.default, { css: styles.box, children: [(0, jsx_runtime_1.jsx)(Close_1.default, { css: styles.close, onClick: onClose }), (0, jsx_runtime_1.jsx)("span", { css: styles.text, children: children })] }) }) }));
};
exports.default = Modal;
//# sourceMappingURL=Modal.js.map